import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Page } from 'npx-family-happy-common';
import { User } from 'src/app/shared/models/user.model';

interface AddressResponse {
  id?: string;
  active?: boolean;
  isDefault?: boolean;
  street?: string;
  city?: string;
  province?: string;
  postalCode?: string;
  zone?: string;
}

@Injectable({
  providedIn: 'root',
})
export class UserManagementService {
  private baseURL = `${
    environment.requestServiceURL.split('/v1')[0]
  }/api/v1/user-controller`;

  private workInfoURL = `${
    environment.requestServiceURL.split('/v1')[0]
  }/v1/user-work-info`;

  constructor(private http: HttpClient) {}

  getUsersList(
    page: number,
    pageSize: number,
    filters?: { uid?: string; email?: string; phone?: string; name?: string }
  ) {
    return this.http.get<Page<User>>(`${this.baseURL}/`, {
      params: { ...filters, page, pageSize },
    });
  }

  createUser(user: User) {
    const body = {
      email: user.email,
      name: user.name,
      phone: user.phone,
      surname: user.surname,
      uid: user.uid,
    };
    return this.http.post<User>(`${this.baseURL}/`, body, {});
  }

  getSingleUser(uid: string) {
    return this.http.get<User>(`${this.baseURL}/${uid}`, {});
  }

  updateUser(user: any) {
    return this.http.patch<User>(
      `${this.baseURL}/${user.uid}/update-profile`,
      user,
      {}
    );
  }

  // addresses
  createUserAddress(addressData: any) {
    const addressBaseURL = `${
      environment.requestServiceURL.split('/v1')[0]
    }/v1/user-address`;
    return this.http.post(addressBaseURL, addressData, {});
  }

  updateUserAddress(addressId: number, addressData: any) {
    const addressBaseURL = `${
      environment.requestServiceURL.split('/v1')[0]
    }/v1/user-address`;
    return this.http.put(`${addressBaseURL}/${addressId}`, addressData, {});
  }

  deleteUserAddress(addressId: number) {
    const addressBaseURL = `${
      environment.requestServiceURL.split('/v1')[0]
    }/v1/user-address`;
    return this.http.delete(`${addressBaseURL}/${addressId}`, {});
  }

  // dependants
  createUserDependant(dependantData: any) {
    const dependantBaseURL = `${
      environment.requestServiceURL.split('/v1')[0]
    }/v1/dependents/`;
    return this.http.post(dependantBaseURL, dependantData, {});
  }
  updateUserDependant(dependantId: number, dependantData: any) {
    const dependantBaseURL = `${
      environment.requestServiceURL.split('/v1')[0]
    }/v1/dependents`;
    return this.http.put(
      `${dependantBaseURL}/${dependantId}`,
      dependantData,
      {}
    );
  }
  deleteUserDependant(dependantId: number) {
    const dependantBaseURL = `${
      environment.requestServiceURL.split('/v1')[0]
    }/v1/dependents`;
    return this.http.delete(`${dependantBaseURL}/${dependantId}`);
  }

  // users
  deleteUser(uid: string) {
    return this.http.delete<string>(`${this.baseURL}/${uid}`, {});
  }
  changeUserRole(uid: string, role: string) {
    return this.http.patch<string>(
      `${this.baseURL}/${uid}?newRole=${role}`,
      {}
    );
  }
  changeUserName(uid: string, name: string, surname: string) {
    return this.http.patch<string>(
      `${this.baseURL}/${uid}/name`,
      {},
      { params: { newName: name, newSurname: surname } }
    );
  }
  sendResetPasswordEmail(email: string) {
    return this.http.get<User>(
      `${this.baseURL}/send-reset-password-email?email=${email}`
    );
  }

  // work info - b2b company
  updateB2bCompany(uid: string, b2bCompanyId: string | null) {
    return this.http.patch<void>(`${this.workInfoURL}/update-user/${uid}`, {
      b2bCompanyId,
    });
  }
}
